const HubUsersEdit = props => {
  return <h1>Hub users edit</h1>
}

export default HubUsersEdit
